module.exports = require("@mui/material/InputLabel");